import React, { useState } from 'react';

const RezLiveSupplierHighlight = () => {
  const [activeTab, setActiveTab] = useState('about');
  const [billingCycle, setBillingCycle] = useState(1); // 1 = Monthly, 2 = Annually

  // Company Information - Zotrai (YOUR COMPANY)
  const companyInfo = {
    name: "Zotrai",
    themeColor: "#FF7F00",
    description: "Your trusted B2B travel technology partner",
    founded: "2020",
    headquarters: "India",
    agents: "10,000+",
    suppliers: "50+",
    countries: "100+",
    uptime: "99.9%",
    apiCalls: "100M+",
    team: "100+",
    email: "support@zotrai.com",
    phone: "+91-7207642485"
  };

  // Why Suppliers Choose Zotrai - REAL DATA
  const whyZotraiData = {
    benefits: [
        {
        id: 1,
        title: "Single API Integration, Multiple Connections",
        description: "Connect once with Zotrai and get instant access to all our partner suppliers - no multiple integrations needed",
        icon: "ri-plug-line",
        stat: "1",
        statLabel: "Integration"
      },
     {
  id: 2,
  title: "Launch B2B, B2C & Corporate Portals",
  description: "Fully customizable multi-agent, direct-sell, and corporate booking platforms under your brand",
  icon: "ri-window-line",
  stat: "All-in-One",
  statLabel: "Portal Suite"
},
    
      {
  id: 3,
  title: "Save 95% on Integration Costs",
  description: "No setup fees, no integration charges.",
icon: "ri-coins-line",

  stat: "95%",
  statLabel: "Cost Savings"
},
      {
        id: 4,
        title: "Real-time Analytics Dashboard",
        description: "Track your inventory performance, booking patterns, and agent behavior with detailed analytics",
        icon: "ri-bar-chart-2-line",
        stat: "24/7",
        statLabel: "Monitoring"
      },
      {
        id: 5,
        title: "99.9% Uptime Guarantee",
        description: "Enterprise-grade infrastructure with redundant systems ensuring your APIs are always available",
        icon: "ri-shield-check-line",
        stat: "99.9%",
        statLabel: "Uptime"
      },
      {
        id: 6,
        title: "Dedicated Account Manager",
        description: "Every supplier gets a dedicated technical account manager for seamless integration and support",
        icon: "ri-customer-service-line",
        stat: "24/7",
        statLabel: "Support"
      }
    ],
    process: [
      {
        step: 1,
        title: "Add Your API Credentials",
        description: "Just Login, paste your API keys, and we handle the rest – zero development effort"
      },
       {
        step: 2,
        title: "Select & Customize Template",
        description: "Pick from our library of 100+ responsive templates and match your brand identity"
      },
      {
        step: 3,
        title: "Go Live Instantly",
        description: "Deploy to production in one click and start accepting real bookings"
      }
    ]
  };
  // SEO-friendly structured data for RezLive
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "RezLive",
    "description": "Cloud-based hotel distribution platform connecting suppliers with travel agents through seamless API integration",
    "url": "https://www.rezlive.com",
    "areaServed": "Worldwide",
    "serviceType": ["Hotel Booking API", "Channel Manager", "Rate Management", "Travel Technology"],
    "parentOrganization": {
      "@type": "Organization",
      "name": "Lepton Software Group"
    }
  };

  // RezLive specific data
  const rezliveData = {
    name: "RezLive",
    description: "Cloud-based hotel distribution platform connecting suppliers with travel agents through seamless API integration. Part of the Lepton Software Group, a leading technology company with 25+ years of experience.",
    longDescription: "RezLive is a premier hotel distribution platform that has revolutionized the way travel agents access and book hotel inventory. As part of the Lepton Software Group, established in 1995, RezLive leverages over two decades of technology expertise to provide a robust, reliable, and feature-rich hotel booking solution. The platform connects thousands of travel agents with millions of hotel properties worldwide through a single, seamless API integration. RezLive is known for its extensive hotel inventory, competitive rates, real-time availability, and instant confirmation capabilities. With a presence in over 180 countries and partnerships with major hotel chains and independent properties, RezLive has become a trusted partner for travel businesses of all sizes.",
    founded: "2010",
    parentCompany: "Lepton Software Group",
    parentFounded: "1995",
    headquarters: "New Delhi, India",
    employees: "500+",
    countries: "180+",
    hotels: "1.2M+",
    properties: "1.2M+",
    apartments: "100K+",
    resorts: "50K+",
    apiCalls: "200M+",
    agents: "25,000+",
    themeColor: "#6B46C1", // RezLive purple color
    website: "https://www.rezlive.com",
    apiType: "XML/REST API",
    integrationType: "Direct API Integration",
    support: "24/7 Multi-lingual Support"
  };

  // Key features of RezLive
  const features = [
    {
      icon: "🏨",
      title: "1.2M+ Hotel Properties",
      description: "Extensive global hotel inventory including chains, boutiques, and independent properties"
    },
    {
      icon: "⚡",
      title: "Real-time Availability",
      description: "Live inventory updates with instant confirmation and cancellation policies"
    },
    {
      icon: "💰",
      title: "Competitive B2B Rates",
      description: "Exclusive wholesale rates and dynamic pricing for travel agents"
    },
    {
      icon: "📊",
      title: "Rate Management",
      description: "Advanced rate management tools with automated yield management"
    }
  ];

  // Services offered by RezLive
  const services = [
    {
      id: 1,
      title: "Hotel Booking API",
      description: "Access to 1.2M+ hotel properties worldwide with real-time availability, dynamic pricing, and instant confirmation.",
      features: [
        "Real-time availability & pricing",
        "Multi-language content",
        "High-resolution images",
        "Cancellation policies",
        "Room upgrades",
        "Special requests"
      ],
      icon: "🏨"
    },
    {
      id: 2,
      title: "Channel Manager",
      description: "Seamless channel management solution for hotels to manage rates and inventory across multiple platforms.",
      features: [
        "Multi-channel distribution",
        "Rate parity management",
        "Inventory synchronization",
        "Automated updates",
        "Booking consolidation",
        "Performance analytics"
      ],
      icon: "📡"
    },
    {
      id: 3,
      title: "Rate Management System",
      description: "Advanced rate management tools for dynamic pricing and yield optimization.",
      features: [
        "Dynamic pricing",
        "Yield management",
        "Promotional rates",
        "Package deals",
        "Last minute deals",
        "Seasonal pricing"
      ],
      icon: "📈"
    },
    {
      id: 4,
      title: "Resorts & Villas",
      description: "Specialized inventory of resorts, villas, and luxury properties for premium travel experiences.",
      features: [
        "Luxury resorts",
        "Private villas",
        "Beach properties",
        "Mountain retreats",
        "Wellness resorts",
        "Boutique hotels"
      ],
      icon: "🏖️"
    },
    {
      id: 5,
      title: "Serviced Apartments",
      description: "Extended stay accommodations with apartment-style amenities for business and leisure travelers.",
      features: [
        "Fully furnished",
        "Kitchen facilities",
        "Weekly/Monthly rates",
        "Corporate housing",
        "Family suites",
        "Business amenities"
      ],
      icon: "🏢"
    },
    {
      id: 6,
      title: "Corporate Accommodations",
      description: "Specialized solutions for corporate travel with negotiated rates and simplified billing.",
      features: [
        "Corporate rates",
        "Centralized billing",
        "Travel policy compliance",
        "Management reports",
        "Employee tracking",
        "Expense integration"
      ],
      icon: "💼"
    }
  ];

  // Technology highlights
  const technology = [
    {
      title: "XML/REST APIs",
      description: "Flexible API options with comprehensive documentation and support"
    },
    {
      title: "Real-time Connectivity",
      description: "Direct connections to hotels ensure real-time availability and rates"
    },
    {
      title: "Multi-language Support",
      description: "API responses in multiple languages for global operations"
    },
    {
      title: "High Availability",
      description: "99.9% uptime with redundant infrastructure"
    },
    {
      title: "Secure Transactions",
      description: "PCI compliant with encrypted data transmission"
    },
    {
      title: "Scalable Architecture",
      description: "Handles millions of concurrent requests during peak seasons"
    }
  ];

  // Integration process
  const integrationProcess = [
    {
      step: 1,
      title: "API Documentation",
      description: "Receive comprehensive API documentation and credentials"
    },
    {
      step: 2,
      title: "Sandbox Testing",
      description: "Test integration in RezLive's staging environment"
    },
    {
      step: 3,
      title: "Go Live",
      description: "Deploy to production with 24/7 technical support"
    }
  ];

  // Why choose RezLive
  const whyChoose = [
    "Part of Lepton Software Group with 25+ years of technology expertise",
    "1.2M+ hotel properties across 180+ countries",
    "Real-time availability and instant confirmation",
    "Multi-language and multi-currency support",
    "Advanced rate management and yield optimization",
    "Dedicated account management and 24/7 support"
  ];

  // Supplier logos array with navigation paths
  const suppliers = [
    { 
      id: 1, 
      name: "Tripjack", 
      logo: "/assets/images/suppliers/tripjack.png",
      path: "/supplier/trip-jack"
    },
    { 
      id: 2, 
      name: "TBO", 
      logo: "/assets/images/suppliers/tbo.png",
      path: "/supplier/tbo"
    },
    { 
      id: 3, 
      name: "Akbar Travels", 
      logo: "/assets/images/suppliers/akbar.png",
      path: "/supplier/akbar-travels"
    },
    { 
      id: 4, 
      name: "RezLive", 
      logo: "/assets/images/suppliers/rezlive.png",
      path: "/supplier/rezlive"
    },
    { 
      id: 5, 
      name: "GRN Connect", 
      logo: "/assets/images/suppliers/grn.png",
      path: "/supplier/grn-connect"
    },
    { 
      id: 6, 
      name: "Riya Travel", 
      logo: "/assets/images/suppliers/riya.png",
      path: "/supplier/riya-travel"
    },
    { 
      id: 7, 
      name: "Viator", 
      logo: "/assets/images/suppliers/viator.png",
      path: "/supplier/viator"
    },
    { 
      id: 8, 
      name: "Air iQ", 
      logo: "/assets/images/suppliers/airiq.png",
      path: "/supplier/air-iq"
    }
  ];

  // Pricing plans data
  const plans = [
    {
      id: 1,
      name: "Starter",
      description: "🚀 All-in-one powerful plan with complete access to every feature.",
      monthly: 2999,
      annually: 29999,
      popular: true,
      emoji: "🚀",
      features: [
        "Search, compare, and book flights from top global suppliers in one place",
        "Access and connect with 1,000+ verified global DMCs",
        "Smart accounting suite with ledgers, invoices, supplier settlements, and corporate payments",
        "Capture leads directly from social media and run promotions from a single dashboard",
        "Generate professional itineraries in minutes using AI",
        "AI-powered visa processing and document management system",
        "One unified platform for Flights, Hotels, Visas, Cars, Sightseeing, and more",
        "Integrated and secure payment gateway",
        "Plug in and manage your own supplier APIs seamlessly",
        "AI-based WhatsApp automation for leads, follow-ups, and customer support",
        "Unlimited email marketing and promotional campaigns",
        "Advanced reports and analytics for sales, revenue, and performance tracking",
      ],
      addons: [
        "Launch your own B2C booking website for customers in minutes – just INR 999",
        "Launch a full-featured B2C travel portal with flights, hotels, and packages using your preferred suppliers – INR 1,999",
        "Launch a B2B travel portal for your agent network with flights, hotels, and packages – INR 1,999",
        "Launch a B2E corporate travel portal for your business clients with flights, hotels, and packages – INR 1,999",
      ],
    },
  ];

  const getAccentColor = (planName) => {
    if (planName === "Starter") return "#10B981";
    if (planName === "Pro") return "#3B82F6";
    return "#8B5CF6";
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${companyInfo.email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${companyInfo.phone.replace(/[^0-9+]/g, '')}`;
  };

  const handleSupplierClick = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>RezLive - Global Hotel Distribution Platform | Zotrai</title>
        <meta name="description" content="RezLive is a premier hotel distribution platform offering 1.2M+ hotel properties worldwide through seamless API integration. Part of Lepton Software Group." />
        <meta name="keywords" content="RezLive supplier, hotel distribution, hotel booking API, channel manager, rate management, B2B hotel bookings" />
        <link rel="canonical" href="https://yourcompany.com/supplier/rezlive" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="RezLive - Global Hotel Distribution Platform" />
        <meta property="og:description" content="Connect with RezLive's extensive network of 1.2M+ hotel properties through Zotrai's single API integration." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Main Content with rezlive- prefix */}
      <div className="rezlive-supplier-container">
        {/* Header Section - RezLive Hero */}
        <header className="rezlive-header">
          <div className="rezlive-container">
            <h1 className="rezlive-title">
              <span className="rezlive-highlight" style={{ color: rezliveData.themeColor }}>RezLive</span>
              <br />
              Global Hotel Distribution Platform
            </h1>
            <p className="rezlive-subtitle">
              {rezliveData.description}
            </p>
          </div>
        </header>

        {/* Tabs Navigation - Same as others */}
        <div className="rezlive-tabs-container">
          <div className="rezlive-container">
            <div className="rezlive-tabs">
              <button 
                className={`rezlive-tab ${activeTab === 'about' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('about')}
              >
                About
              </button>
              <button 
                className={`rezlive-tab ${activeTab === 'services' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('services')}
              >
                Services
              </button>
              <button 
                className={`rezlive-tab ${activeTab === 'technology' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('technology')}
              >
                Technology
              </button>
              <button 
                className={`rezlive-tab ${activeTab === 'whyzotrai' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('whyzotrai')}
              >
                Why Zotrai <span className="rezlive-tab-badge">For Suppliers</span>
              </button>
              <button 
                className={`rezlive-tab ${activeTab === 'suppliers' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('suppliers')}
              >
                Suppliers
              </button>
              <button 
                className={`rezlive-tab ${activeTab === 'pricing' ? 'rezlive-tab-active' : ''}`}
                onClick={() => setActiveTab('pricing')}
              >
                Pricing
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="rezlive-tab-content">
          {activeTab === 'about' && (
            <section className="rezlive-about">
              <div className="rezlive-container">
                <div className="rezlive-grid">
                  <div className="rezlive-about-content">
                    <h2 className="rezlive-section-title">About <span className="rezlive-accent" style={{ color: rezliveData.themeColor }}>RezLive</span></h2>
                    <p className="rezlive-text">
                      {rezliveData.longDescription}
                    </p>
                    
                    <div className="rezlive-features">
                      {features.map((feature, index) => (
                        <div key={index} className="rezlive-feature">
                          <span className="rezlive-feature-icon">{feature.icon}</span>
                          <div>
                            <h4>{feature.title}</h4>
                            <p>{feature.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="rezlive-card">
                    <h3 className="rezlive-card-title">RezLive at a Glance</h3>
                    <ul className="rezlive-list">
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        Part of Lepton Software Group (Est. 1995)
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        1.2M+ Hotel Properties
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        180+ Countries Coverage
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        100K+ Serviced Apartments
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        50K+ Resorts & Villas
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        25,000+ Active Travel Agents
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        Real-time Availability
                      </li>
                      <li className="rezlive-list-item">
                        <span className="rezlive-check" style={{ color: rezliveData.themeColor }}>✓</span>
                        24/7 Multi-lingual Support
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'services' && (
            <section className="rezlive-services">
              <div className="rezlive-container">
                <h2 className="rezlive-section-title rezlive-text-center">
                  Comprehensive Hotel Solutions
                </h2>
                <p className="rezlive-section-subtitle">
                  Through our integration with RezLive, we deliver end-to-end hotel distribution technology solutions
                </p>

                <div className="rezlive-services-grid">
                  {services.map((service) => (
                    <div key={service.id} className="rezlive-service-card">
                      <div className="rezlive-service-icon">{service.icon}</div>
                      <h3 className="rezlive-service-title">{service.title}</h3>
                      <p className="rezlive-service-description">{service.description}</p>
                      <ul className="rezlive-service-list">
                        {service.features.map((feature, index) => (
                          <li key={index} className="rezlive-service-list-item">
                            <span className="rezlive-dot" style={{ color: rezliveData.themeColor }}>•</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {activeTab === 'technology' && (
            <section className="rezlive-technology">
              <div className="rezlive-container">
                <div className="rezlive-grid">
                  <div className="rezlive-integration-box">
                    <h3 className="rezlive-card-title">Seamless Integration</h3>
                    <p className="rezlive-text">
                      Our integration with RezLive's robust APIs ensures smooth data flow, real-time updates, and reliable performance. This technology partnership enables us to deliver exceptional hotel booking services.
                    </p>
                    <div className="rezlive-tags">
                      {technology.map((tech, index) => (
                        <span key={index} className="rezlive-tag">{tech.title}</span>
                      ))}
                    </div>
                  </div>

                  <div className="rezlive-benefits-box">
                    <h3 className="rezlive-card-title">Key Advantages</h3>
                    <ul className="rezlive-benefits-list">
                      <li className="rezlive-benefits-item">
                        <span className="rezlive-benefits-icon">⚡</span>
                        Lightning-fast API response times
                      </li>
                      <li className="rezlive-benefits-item">
                        <span className="rezlive-benefits-icon">🛡️</span>
                        Enterprise-grade security protocols
                      </li>
                      <li className="rezlive-benefits-item">
                        <span className="rezlive-benefits-icon">🎧</span>
                        Dedicated technical support
                      </li>
                      <li className="rezlive-benefits-item">
                        <span className="rezlive-benefits-icon">👥</span>
                        Experienced integration team
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'whyzotrai' && (
            <section className="rezlive-why-zotrai-section">
              <div className="rezlive-container">
                {/* Header */}
                <div className="rezlive-why-header">
                  <span className="rezlive-why-badge" style={{ background: `${companyInfo.themeColor}15`, color: companyInfo.themeColor }}>
                    <i className="ri-question-line"></i> WHY SUPPLIERS CHOOSE ZOTRAI
                  </span>
                  <h2 className="rezlive-section-title">
                    Your Growth Partner in <span className="rezlive-accent" style={{ color: companyInfo.themeColor }}>Travel Distribution</span>
                  </h2>
                  <p className="rezlive-section-subtitle">
                    Join 50+ leading travel suppliers who trust us to connect them with travel agents
                  </p>
                </div>

                {/* Benefits Grid */}
                <div className="rezlive-benefits-grid-full">
                  {whyZotraiData.benefits.map((benefit) => (
                    <div key={benefit.id} className="rezlive-benefit-card">
                      <div className="rezlive-benefit-icon-wrapper" style={{ background: `${companyInfo.themeColor}15` }}>
                        <i className={benefit.icon} style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="rezlive-benefit-content">
                        <h3>{benefit.title}</h3>
                        <p>{benefit.description}</p>
                        <div className="rezlive-benefit-stat">
                          <span className="rezlive-stat-highlight" style={{ color: companyInfo.themeColor }}>{benefit.stat}</span>
                          <span className="rezlive-stat-label">{benefit.statLabel}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Integration Process */}
                <div className="rezlive-integration-process">
                  <h3 className="rezlive-process-title">Simple 3-Step Integration</h3>
                  <div className="rezlive-process-steps">
                    {whyZotraiData.process.map((step) => (
                      <div key={step.step} className="rezlive-process-step">
                        <div className="rezlive-step-number" style={{ background: companyInfo.themeColor }}>{step.step}</div>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Section */}
                <div className="rezlive-contact-section">
                  <h3>Ready to Join Our Supplier Network?</h3>
                  <p>Connect with agents through a single integration</p>
                  
                  <div className="rezlive-contact-info">
                    <div className="rezlive-contact-item" onClick={handleEmailClick}>
                      <div className="rezlive-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-mail-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="rezlive-contact-details">
                        <span className="rezlive-contact-label">Email Support</span>
                        <span className="rezlive-contact-value">{companyInfo.email}</span>
                      </div>
                    </div>

                    <div className="rezlive-contact-item" onClick={handlePhoneClick}>
                      <div className="rezlive-contact-icon" style={{ backgroundColor: `${companyInfo.themeColor}15` }}>
                        <i className="ri-phone-line" style={{ color: companyInfo.themeColor }}></i>
                      </div>
                      <div className="rezlive-contact-details">
                        <span className="rezlive-contact-label">Phone Support</span>
                        <span className="rezlive-contact-value">{companyInfo.phone}</span>
                      </div>
                    </div>
                  </div>

                  <p className="rezlive-contact-note">
                    Our support team is available 24/7 to assist you with any questions
                  </p>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'suppliers' && (
            <section className="rezlive-suppliers-section">
              <div className="rezlive-container">
                {/* Section Header */}
                <div className="rezlive-suppliers-header">
                  <span className="rezlive-suppliers-badge">
                    <i className="ri-handshake-line"></i> OUR INTEGRATED SUPPLIERS
                  </span>
                  <h2 className="rezlive-section-title">
                    Connect With <span className="rezlive-accent">Leading Travel Suppliers</span>
                  </h2>
                  <p className="rezlive-section-subtitle">
                    Direct integrations with industry-leading travel suppliers worldwide
                  </p>
                </div>

                {/* Clickable Logo Grid */}
                <div className="rezlive-logo-grid">
                  {suppliers.map((supplier) => (
                    <div 
                      key={supplier.id} 
                      className="rezlive-logo-item rezlive-clickable"
                      onClick={() => handleSupplierClick(supplier.path)}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          handleSupplierClick(supplier.path);
                        }
                      }}
                    >
                      <div className="rezlive-logo-wrapper">
                        <img 
                          src={supplier.logo} 
                          alt={supplier.name}
                          className="rezlive-supplier-logo"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://via.placeholder.com/80x40?text=${supplier.name.charAt(0)}`;
                          }}
                        />
                      </div>
                      <span className="rezlive-logo-name">{supplier.name}</span>
                      <span className="rezlive-view-details-hint">
                        View Details <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  ))}
                </div>

                {/* Simple Stats */}
                <div className="rezlive-supplier-stats-simple">
                  
                  <div className="rezlive-stat-simple">
                    <span className="rezlive-stat-number">1M+</span>
                    <span className="rezlive-stat-label">Hotel Properties</span>
                  </div>
                  <div className="rezlive-stat-simple">
                    <span className="rezlive-stat-number">80+</span>
                    <span className="rezlive-stat-label">Airlines</span>
                  </div>
                  <div className="rezlive-stat-simple">
                    <span className="rezlive-stat-number">300K+</span>
                    <span className="rezlive-stat-label">Activities</span>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 'pricing' && (
            <section className="rezlive-pricing-section">
              <div className="rezlive-container">
                <div className="rezlive-pricing-header">
                  <h2 className="rezlive-section-title rezlive-text-center">
                    Plans & <span className="rezlive-accent">Pricing</span>
                  </h2>
                  <p className="rezlive-section-subtitle">
                    Pick the plan that's right for your business growth
                  </p>
                  
                  {/* Billing Toggle */}
                  <div className="rezlive-billing-toggle">
                    <button
                      className={`rezlive-toggle-btn ${billingCycle === 1 ? 'rezlive-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(1)}
                    >
                      Monthly
                    </button>
                    <button
                      className={`rezlive-toggle-btn ${billingCycle === 2 ? 'rezlive-toggle-active' : ''}`}
                      onClick={() => setBillingCycle(2)}
                    >
                      Annually
                      <span className="rezlive-save-badge">Save 20%</span>
                    </button>
                  </div>
                </div>

                {/* Pricing Cards */}
                <div className="rezlive-pricing-grid">
                  {plans.map((plan) => {
                    const isMonthly = billingCycle === 1;
                    const accentColor = getAccentColor(plan.name);
                    
                    return (
                      <div key={plan.id} className="rezlive-pricing-card-enhanced">
                        {plan.popular && (
                          <div className="rezlive-popular-badge">
                            ⭐ MOST POPULAR
                          </div>
                        )}

                        <div className="rezlive-pricing-card-content">
                          {/* Pricing Side */}
                          <div className="rezlive-pricing-left" style={{ backgroundColor: plan.popular ? '#F4F9FF' : '#ffffff' }}>
                            <div className="rezlive-pricing-emoji">{plan.emoji}</div>
                            <h3 className="rezlive-pricing-name">{plan.name}</h3>
                            <p className="rezlive-pricing-description">{plan.description}</p>

                            <div className="rezlive-pricing-amount">
                              <span className="rezlive-currency">INR</span>
                              <span className="rezlive-price">
                                {isMonthly ? plan.monthly.toLocaleString() : plan.annually.toLocaleString()}
                              </span>
                              <span className="rezlive-pricing-period">
                                /{isMonthly ? 'month' : 'year'}
                              </span>
                            </div>

                            <button 
                              className="rezlive-pricing-cta"
                              style={{ backgroundColor: accentColor }}
                              onClick={() => window.location.href = '/signup'}
                            >
                              Start Free Trial <i className="ri-arrow-right-line"></i>
                            </button>

                            {/* Quick 3-Step Setup */}
                            <div className="rezlive-quick-setup">
                              <h4 className="rezlive-setup-title">Quick 3-Step Setup</h4>
                              <div className="rezlive-setup-steps">
                                <div className="rezlive-setup-step">
                                  <div className="rezlive-step-marker" style={{ background: accentColor }}>1</div>
                                  <div className="rezlive-step-content">
                                    <strong>Sign Up & Choose Plan</strong>
                                    <span>Create your account in 30 seconds - no credit card required</span>
                                  </div>
                                </div>
                                <div className="rezlive-setup-step">
                                  <div className="rezlive-step-marker" style={{ background: accentColor }}>2</div>
                                  <div className="rezlive-step-content">
                                    <strong>Select Your Suppliers</strong>
                                    <span>Choose from leading travel suppliers with one click</span>
                                  </div>
                                </div>
                                <div className="rezlive-setup-step">
                                  <div className="rezlive-step-marker" style={{ background: accentColor }}>3</div>
                                  <div className="rezlive-step-content">
                                    <strong>Launch Your Portal</strong>
                                    <span>Go live with your branded website in minutes</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Features Side */}
                          <div className="rezlive-pricing-right">
                            <h5 className="rezlive-features-title" style={{ color: accentColor }}>
                              Included in {plan.name}
                            </h5>
                            
                            <div className="rezlive-features-list">
                              {plan.features.map((feature, index) => (
                                <div key={index} className="rezlive-feature-item">
                                  <div className="rezlive-feature-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-check-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{feature}</span>
                                </div>
                              ))}
                            </div>

                            <h5 className="rezlive-features-title rezlive-addons-title" style={{ color: accentColor }}>
                              Add-Ons
                            </h5>
                            
                            <div className="rezlive-addons-list">
                              {plan.addons.map((addon, index) => (
                                <div key={index} className="rezlive-addon-item">
                                  <div className="rezlive-addon-check" style={{ backgroundColor: `${accentColor}15` }}>
                                    <i className="ri-add-line" style={{ color: accentColor }}></i>
                                  </div>
                                  <span>{addon}</span>
                                </div>
                              ))}
                            </div>

                            <div className="rezlive-pricing-footer">
                              <span>✓ Transparent pricing, no hidden fees</span>
                              <span className="rezlive-support-link" style={{ color: accentColor }}>
                                Need help? Chat with us
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          )}
        </div>
      </div>

      {/* Styles with rezlive- prefix */}
      <style jsx>{`
        .rezlive-supplier-container {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
          line-height: 1.6;
          color: #1e293b;
        }

        .rezlive-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Header Styles */
        .rezlive-header {
          background: #ffffff;
          color: #1e293b;
          padding: 80px 0 40px;
          text-align: center;
        }

        .rezlive-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin: 0 0 15px;
          line-height: 1.2;
          color: #1e293b;
        }

        .rezlive-highlight {
          font-size: 4rem;
          display: inline-block;
          font-weight: 800;
        }

        .rezlive-subtitle {
          font-size: 1.25rem;
          max-width: 700px;
          margin: 0 auto;
          color: #475569;
        }

        /* Tabs Navigation */
        .rezlive-tabs-container {
          background: #ffffff;
          border-bottom: 2px solid #e2e8f0;
          margin-bottom: 40px;
          position: sticky;
          top: 0;
          z-index: 100;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95);
        }

        .rezlive-tabs {
          display: flex;
          gap: 30px;
          overflow-x: auto;
          padding: 0 24px;
        }

        .rezlive-tab {
          background: none;
          border: none;
          padding: 16px 0;
          font-size: 1rem;
          font-weight: 600;
          color: #64748b;
          cursor: pointer;
          position: relative;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }

        .rezlive-tab:hover {
          color: #0f172a;
        }

        .rezlive-tab-active {
          color: #0f172a;
        }

        .rezlive-tab-active::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 3px;
          background: ${rezliveData.themeColor};
        }

        .rezlive-tab-badge {
          background: ${rezliveData.themeColor};
          color: white;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          font-weight: 500;
        }

        /* About Section */
        .rezlive-about {
          padding: 40px 0 60px;
          background: #ffffff;
        }

        .rezlive-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 50px;
          align-items: start;
        }

        .rezlive-section-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .rezlive-text-center {
          text-align: center;
        }

        .rezlive-accent {
          position: relative;
          display: inline-block;
        }

        .rezlive-accent::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 4px;
          background: ${rezliveData.themeColor};
          border-radius: 2px;
        }

        .rezlive-text {
          font-size: 1.1rem;
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.8;
        }

        .rezlive-features {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin-top: 30px;
        }

        .rezlive-feature {
          display: flex;
          gap: 15px;
          padding: 20px;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .rezlive-feature:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          border-color: ${rezliveData.themeColor};
        }

        .rezlive-feature-icon {
          font-size: 2rem;
          min-width: 50px;
        }

        .rezlive-feature h4 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 5px;
          color: #0f172a;
        }

        .rezlive-feature p {
          font-size: 0.95rem;
          color: #475569;
          margin: 0;
        }

        .rezlive-card {
          background: white;
          padding: 40px;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
        }

        .rezlive-card-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 24px;
          color: #0f172a;
        }

        .rezlive-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .rezlive-list-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
          font-size: 1rem;
          color: #334155;
        }

        .rezlive-check {
          font-weight: bold;
          font-size: 1.2rem;
        }

        /* Services Section */
        .rezlive-services {
          padding: 40px 0 60px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .rezlive-section-subtitle {
          font-size: 1.25rem;
          color: #475569;
          text-align: center;
          max-width: 700px;
          margin: 0 auto 50px;
        }

        .rezlive-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .rezlive-service-card {
          background: white;
          padding: 35px 25px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
        }

        .rezlive-service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: ${rezliveData.themeColor};
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }

        .rezlive-service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(107, 70, 193, 0.1);
        }

        .rezlive-service-card:hover::before {
          transform: scaleX(1);
        }

        .rezlive-service-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }

        .rezlive-service-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .rezlive-service-description {
          color: #475569;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .rezlive-service-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .rezlive-service-list-item {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          color: #475569;
          font-size: 0.95rem;
        }

        .rezlive-dot {
          font-weight: bold;
        }

        /* Technology Section */
        .rezlive-technology {
          padding: 40px 0 60px;
          background: white;
        }

        .rezlive-integration-box,
        .rezlive-benefits-box {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 40px;
          border-radius: 24px;
          border: 1px solid #eef2f6;
        }

        .rezlive-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 25px;
        }

        .rezlive-tag {
          background: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-size: 0.9rem;
          color: ${rezliveData.themeColor};
          font-weight: 500;
          border: 1px solid ${rezliveData.themeColor}30;
          transition: all 0.3s ease;
        }

        .rezlive-tag:hover {
          background: ${rezliveData.themeColor};
          color: white;
          border-color: ${rezliveData.themeColor};
          transform: scale(1.05);
        }

        .rezlive-benefits-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .rezlive-benefits-item {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          font-size: 1.1rem;
          color: #1e293b;
        }

        .rezlive-benefits-icon {
          font-size: 1.5rem;
          background: white;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        /* Why Zotrai Section */
        .rezlive-why-zotrai-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .rezlive-why-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .rezlive-why-badge {
          display: inline-block;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
        }

        .rezlive-benefits-grid-full {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 25px;
          margin-bottom: 50px;
        }

        .rezlive-benefit-card {
          display: flex;
          gap: 20px;
          background: #f8fafc;
          padding: 25px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
        }

        .rezlive-benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.05);
          border-color: ${companyInfo.themeColor};
        }

        .rezlive-benefit-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .rezlive-benefit-icon-wrapper i {
          font-size: 2rem;
        }

        .rezlive-benefit-content h3 {
          font-size: 1.2rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .rezlive-benefit-content p {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 12px;
          line-height: 1.6;
        }

        .rezlive-benefit-stat {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .rezlive-stat-highlight {
          font-size: 1.2rem;
          font-weight: 700;
        }

        .rezlive-integration-process {
          text-align: center;
          margin: 60px 0;
        }

        .rezlive-process-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #0f172a;
        }

        .rezlive-process-steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        .rezlive-process-step {
          text-align: center;
          padding: 30px;
          background: #f8fafc;
          border-radius: 20px;
          border: 1px solid #eef2f6;
        }

        .rezlive-process-step .rezlive-step-number {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 20px;
        }

        /* Contact Section */
        .rezlive-contact-section {
          background: #ffffff;
          padding: 60px;
          border-radius: 30px;
          text-align: center;
          color: #0f172a;
          margin-top: 60px;
          border: 2px solid #eef2f6;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
        }

        .rezlive-contact-section h3 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 15px;
          color: #0f172a;
        }

        .rezlive-contact-section p {
          font-size: 1.2rem;
          color: #475569;
          margin-bottom: 40px;
        }

        .rezlive-contact-info {
          display: flex;
          justify-content: center;
          gap: 30px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .rezlive-contact-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 30px;
          background: #f8fafc;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 280px;
        }

        .rezlive-contact-item:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: ${companyInfo.themeColor};
        }

        .rezlive-contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .rezlive-contact-icon i {
          font-size: 1.8rem;
        }

        .rezlive-contact-details {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .rezlive-contact-label {
          font-size: 0.85rem;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .rezlive-contact-value {
          font-size: 1.2rem;
          font-weight: 600;
          color: #0f172a;
        }

        .rezlive-contact-note {
          font-size: 0.95rem !important;
          color: #64748b !important;
          margin-top: 20px;
          margin-bottom: 0 !important;
        }

        /* Suppliers Section */
        .rezlive-suppliers-section {
          padding: 40px 0 80px;
          background: #ffffff;
        }

        .rezlive-suppliers-header {
          text-align: center;
          margin-bottom: 50px;
        }

        .rezlive-suppliers-badge {
          display: inline-block;
          background: linear-gradient(135deg, #2563eb15, #7c3aed15);
          color: #2563eb;
          padding: 8px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 20px;
          border: 1px solid #2563eb20;
        }

        .rezlive-suppliers-badge i {
          margin-right: 8px;
        }

        .rezlive-logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-bottom: 50px;
        }

        .rezlive-logo-item {
          text-align: center;
          padding: 20px;
          background: white;
          border-radius: 16px;
          border: 1px solid #eef2f6;
          transition: all 0.3s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .rezlive-logo-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(37, 99, 235, 0.15);
          border-color: #2563eb;
        }

        .rezlive-logo-item:hover .rezlive-view-details-hint {
          opacity: 1;
          transform: translateY(0);
        }

        .rezlive-logo-wrapper {
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 15px;
        }

        .rezlive-supplier-logo {
          max-width: 120px;
          max-height: 60px;
          object-fit: contain;
          transition: transform 0.3s ease;
        }

        .rezlive-logo-item:hover .rezlive-supplier-logo {
          transform: scale(1.05);
        }

        .rezlive-logo-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1e293b;
          display: block;
          margin-bottom: 5px;
        }

        .rezlive-view-details-hint {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          font-size: 0.8rem;
          color: #2563eb;
          font-weight: 500;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .rezlive-supplier-stats-simple {
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: linear-gradient(135deg, #f8fafc, #ffffff);
          padding: 30px;
          border-radius: 20px;
          border: 1px solid #eef2f6;
          flex-wrap: wrap;
          gap: 20px;
        }

        .rezlive-stat-simple {
          text-align: center;
        }

        .rezlive-stat-simple .rezlive-stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #2563eb;
          line-height: 1.2;
        }

        .rezlive-stat-simple .rezlive-stat-label {
          font-size: 0.9rem;
          color: #64748b;
        }

        /* Pricing Section */
        .rezlive-pricing-section {
          padding: 40px 0 80px;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        }

        .rezlive-pricing-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .rezlive-billing-toggle {
          display: inline-flex;
          background: white;
          padding: 4px;
          border-radius: 50px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          margin-top: 20px;
        }

        .rezlive-toggle-btn {
          border: none;
          padding: 12px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          background: transparent;
          color: #64748b;
          position: relative;
        }

        .rezlive-toggle-active {
          background: #2563eb;
          color: white;
        }

        .rezlive-save-badge {
          background: #fbbf24;
          color: #1e293b;
          font-size: 0.7rem;
          padding: 2px 8px;
          border-radius: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .rezlive-pricing-grid {
          max-width: 1000px;
          margin: 0 auto;
        }

        .rezlive-pricing-card-enhanced {
          background: white;
          border-radius: 24px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
          border: 1px solid #eef2f6;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .rezlive-pricing-card-enhanced:hover {
          transform: translateY(-5px);
          box-shadow: 0 30px 60px rgba(37, 99, 235, 0.12);
        }

        .rezlive-popular-badge {
          position: absolute;
          top: 20px;
          right: 30px;
          background: #2563eb;
          color: white;
          padding: 8px 16px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 0.85rem;
          z-index: 10;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        }

        .rezlive-pricing-card-content {
          display: grid;
          grid-template-columns: 1fr 1.2fr;
        }

        .rezlive-pricing-left {
          padding: 40px;
          border-right: 1px solid #eef2f6;
        }

        .rezlive-pricing-emoji {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .rezlive-pricing-name {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .rezlive-pricing-description {
          color: #475569;
          font-size: 0.95rem;
          margin-bottom: 25px;
        }

        .rezlive-pricing-amount {
          margin-bottom: 25px;
        }

        .rezlive-currency {
          font-size: 1.2rem;
          font-weight: 600;
          color: #64748b;
          margin-right: 5px;
        }

        .rezlive-price {
          font-size: 3.5rem;
          font-weight: 800;
          color: #0f172a;
          line-height: 1;
        }

        .rezlive-pricing-period {
          font-size: 1rem;
          color: #64748b;
          margin-left: 5px;
        }

        .rezlive-pricing-cta {
          width: 100%;
          border: none;
          padding: 16px;
          border-radius: 12px;
          color: white;
          font-weight: 600;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 30px;
        }

        .rezlive-pricing-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }

        .rezlive-quick-setup {
          background: #f8fafc;
          border-radius: 16px;
          padding: 20px;
        }

        .rezlive-setup-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .rezlive-setup-steps {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .rezlive-setup-step {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .rezlive-step-marker {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 0.9rem;
          flex-shrink: 0;
        }

        .rezlive-step-content {
          display: flex;
          flex-direction: column;
        }

        .rezlive-step-content strong {
          font-size: 0.95rem;
          margin-bottom: 4px;
        }

        .rezlive-step-content span {
          font-size: 0.85rem;
          color: #64748b;
        }

        .rezlive-pricing-right {
          padding: 40px;
          background: #ffffff;
        }

        .rezlive-features-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .rezlive-addons-title {
          margin-top: 30px;
        }

        .rezlive-features-list,
        .rezlive-addons-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .rezlive-feature-item,
        .rezlive-addon-item {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .rezlive-feature-check,
        .rezlive-addon-check {
          width: 22px;
          height: 22px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .rezlive-feature-check i,
        .rezlive-addon-check i {
          font-size: 14px;
        }

        .rezlive-feature-item span,
        .rezlive-addon-item span {
          font-size: 0.95rem;
          color: #334155;
          line-height: 1.5;
        }

        .rezlive-pricing-footer {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
        }

        .rezlive-support-link {
          cursor: pointer;
          font-weight: 500;
        }

        .rezlive-support-link:hover {
          text-decoration: underline;
        }

        /* Accessibility */
        .rezlive-clickable:focus-visible {
          outline: 3px solid #2563eb;
          outline-offset: 2px;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .rezlive-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }
          
          .rezlive-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .rezlive-benefits-grid-full {
            grid-template-columns: 1fr;
          }

          .rezlive-process-steps {
            grid-template-columns: 1fr;
          }

          .rezlive-logo-grid {
            grid-template-columns: repeat(3, 1fr);
          }

          .rezlive-pricing-card-content {
            grid-template-columns: 1fr;
          }

          .rezlive-pricing-left {
            border-right: none;
            border-bottom: 1px solid #eef2f6;
          }

          .rezlive-contact-info {
            flex-direction: column;
            align-items: center;
          }

          .rezlive-contact-item {
            width: 100%;
            max-width: 400px;
          }
        }

        @media (max-width: 768px) {
          .rezlive-title {
            font-size: 2.5rem;
          }
          
          .rezlive-highlight {
            font-size: 3rem;
          }
          
          .rezlive-tabs {
            gap: 20px;
            overflow-x: auto;
            padding-bottom: 5px;
          }
          
          .rezlive-tab {
            font-size: 0.95rem;
            white-space: nowrap;
          }
          
          .rezlive-services-grid {
            grid-template-columns: 1fr;
          }
          
          .rezlive-section-title {
            font-size: 2rem;
          }

          .rezlive-features {
            grid-template-columns: 1fr;
          }

          .rezlive-logo-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .rezlive-supplier-stats-simple {
            flex-direction: column;
            gap: 20px;
          }

          .rezlive-contact-section {
            padding: 40px 20px;
          }

          .rezlive-contact-section h3 {
            font-size: 1.8rem;
          }

          .rezlive-contact-item {
            padding: 15px 20px;
          }

          .rezlive-contact-value {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .rezlive-header {
            padding: 60px 0 30px;
          }

          .rezlive-logo-grid {
            grid-template-columns: 1fr;
          }

          .rezlive-pricing-left,
          .rezlive-pricing-right {
            padding: 25px;
          }

          .rezlive-price {
            font-size: 2.5rem;
          }

          .rezlive-billing-toggle {
            flex-direction: column;
            width: 100%;
            border-radius: 12px;
          }

          .rezlive-toggle-btn {
            width: 100%;
          }

          .rezlive-contact-item {
            flex-direction: column;
            text-align: center;
          }

          .rezlive-contact-details {
            align-items: center;
          }
        }
      `}</style>
    </>
  );
};

// Simple Helmet component for meta tags
const Helmet = ({ children }) => {
  return <>{children}</>;
};

export default RezLiveSupplierHighlight;